import './Article.css.proxy.js';
/* src/components/news/Article.svelte generated by Svelte v3.35.0 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { News } from "../../_modules/news/index.js";
import Content from "../slot/Content.js";
import Center from "../slot/Center.js";

function create_if_block_1(ctx) {
	let center;
	let current;

	center = new Center({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(center.$$.fragment);
		},
		l(nodes) {
			claim_component(center.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(center, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const center_changes = {};

			if (dirty & /*$$scope, news*/ 3) {
				center_changes.$$scope = { dirty, ctx };
			}

			center.$set(center_changes);
		},
		i(local) {
			if (current) return;
			transition_in(center.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(center.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(center, detaching);
		}
	};
}

// (7:123) <Center>
function create_default_slot_1(ctx) {
	let figure;
	let img;
	let img_src_value;
	let img_alt_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				alt: true,
				loading: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*news*/ ctx[0].featuredImage.getSized("large"))) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*news*/ ctx[0].title);
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-pdj69b");
			attr(figure, "class", "svelte-pdj69b");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 1 && img.src !== (img_src_value = /*news*/ ctx[0].featuredImage.getSized("large"))) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*news*/ 1 && img_alt_value !== (img_alt_value = /*news*/ ctx[0].title)) {
				attr(img, "alt", img_alt_value);
			}
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (7:246) {#if news.content}
function create_if_block(ctx) {
	let div;
	let content;
	let current;

	content = new Content({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(content.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(content.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "content svelte-pdj69b");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(content, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const content_changes = {};

			if (dirty & /*$$scope, news*/ 3) {
				content_changes.$$scope = { dirty, ctx };
			}

			content.$set(content_changes);
		},
		i(local) {
			if (current) return;
			transition_in(content.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(content.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(content);
		}
	};
}

// (7:285) <Content>
function create_default_slot(ctx) {
	let html_tag;
	let raw_value = /*news*/ ctx[0].content + "";
	let html_anchor;

	return {
		c() {
			html_anchor = empty();
			this.h();
		},
		l(nodes) {
			html_anchor = empty();
			this.h();
		},
		h() {
			html_tag = new HtmlTag(html_anchor);
		},
		m(target, anchor) {
			html_tag.m(raw_value, target, anchor);
			insert(target, html_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 1 && raw_value !== (raw_value = /*news*/ ctx[0].content + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(html_anchor);
			if (detaching) html_tag.d();
		}
	};
}

function create_fragment(ctx) {
	let article;
	let div;
	let p;
	let t0_value = /*news*/ ctx[0].dateFormatted() + "";
	let t0;
	let h1;
	let t1_value = /*news*/ ctx[0].title + "";
	let t1;
	let if_block0_anchor;
	let current;
	let if_block0 = /*news*/ ctx[0].featuredImage && create_if_block_1(ctx);
	let if_block1 = /*news*/ ctx[0].content && create_if_block(ctx);

	return {
		c() {
			article = element("article");
			div = element("div");
			p = element("p");
			t0 = text(t0_value);
			h1 = element("h1");
			t1 = text(t1_value);
			if (if_block0) if_block0.c();
			if_block0_anchor = empty();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			article = claim_element(nodes, "ARTICLE", {});
			var article_nodes = children(article);
			div = claim_element(article_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, t0_value);
			p_nodes.forEach(detach);
			h1 = claim_element(div_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t1 = claim_text(h1_nodes, t1_value);
			h1_nodes.forEach(detach);
			div_nodes.forEach(detach);
			if (if_block0) if_block0.l(article_nodes);
			if_block0_anchor = empty();
			if (if_block1) if_block1.l(article_nodes);
			article_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "date svelte-pdj69b");
			attr(h1, "class", "svelte-pdj69b");
			attr(div, "class", "heading svelte-pdj69b");
		},
		m(target, anchor) {
			insert(target, article, anchor);
			append(article, div);
			append(div, p);
			append(p, t0);
			append(div, h1);
			append(h1, t1);
			if (if_block0) if_block0.m(article, null);
			append(article, if_block0_anchor);
			if (if_block1) if_block1.m(article, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*news*/ 1) && t0_value !== (t0_value = /*news*/ ctx[0].dateFormatted() + "")) set_data(t0, t0_value);
			if ((!current || dirty & /*news*/ 1) && t1_value !== (t1_value = /*news*/ ctx[0].title + "")) set_data(t1, t1_value);

			if (/*news*/ ctx[0].featuredImage) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*news*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(article, if_block0_anchor);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*news*/ ctx[0].content) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*news*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(article, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(article);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { news } = $$props;

	$$self.$$set = $$props => {
		if ("news" in $$props) $$invalidate(0, news = $$props.news);
	};

	return [news];
}

class Article extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { news: 0 });
	}
}

export default Article;
//# sourceMappingURL=Article.js.map
